<template>
  <div v-if="packedLinks.length" class="tiles-group">
    <div class="tiles-group__header">
      <div class="tiles-group__title">
        {{ title }}
      </div>
    </div>

    <div class="tiles-group__tiles">
      <v-row>
        <v-col
          v-for="(link, key) in packedLinks"
          :key="key"
          :cols="12"
          :md="link.cols || 12"
        >
          <v-btn
            :to="(link.soon || !link.routeName) ? undefined : { name: link.routeName, params: link.params || {} }"
            :disabled="link.soon || !link.routeName"
            block
            large
            class="tiles-group__btn"
          >
            <span :class="['tiles-group__icon', { 'tiles-group__icon_disabled': link.soon || !link.routeName }]">
              <font-awesome-icon :icon="parseIcon(link.icon)" />
            </span>
            <span class="tiles-group__label">{{ link.title }}</span>
            <span v-if="link.soon" class="tiles-group__soon-badge">скоро</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TilesGroup',
    props: {
      title: { type: String, default: '' },
      links: { type: Array, default: () => [] },
    },
    computed: {
      visibleLinks () {
        return this.links.filter((l) => !l.permissions || this.userCan(l.permissions))
      },
      packedLinks () {
        const links = this.visibleLinks
        if (!links.length) return []
        if (links.every((l) => l.cols)) return this.stretchLonelyTiles(links)

        const n = links.length
        const out = links.map((l) => ({ ...l }))
        if (n === 1) {
          out[0].cols = 12
        } else if (n === 2) {
          out.forEach((l) => { l.cols = 12 })
        } else if (n === 3) {
          out[0].cols = 6
          out[1].cols = 6
          out[2].cols = 12
        } else if (n === 4) {
          out.forEach((l) => { l.cols = 6 })
        } else {
          out.forEach((l) => { l.cols = l.cols || 6 })
        }
        return out
      },
    },
    methods: {
      // Плитки с явным cols раскладываем по строкам (сумма до 12): если после скрытия
      // недоступных в строке осталась одна плитка, она занимает всю строку
      stretchLonelyTiles (links) {
        const rows = []
        let row = []
        let width = 0
        links.forEach((link) => {
          if (width + link.cols > 12) {
            rows.push(row)
            row = []
            width = 0
          }
          row.push({ ...link })
          width += link.cols
        })
        rows.push(row)

        return rows.flatMap((r) => {
          if (r.length === 1) r[0].cols = 12
          return r
        })
      },
      parseIcon (icon) {
        if (Array.isArray(icon)) return icon
        if (!icon) return ['fas', 'circle']
        const parts = icon.trim().split(/\s+/)
        if (parts.length === 2) {
          return [parts[0], parts[1].replace(/^fa-/, '')]
        }
        return ['fas', parts[0].replace(/^fa-/, '')]
      },
    },
  }
</script>

<style lang="less" scoped>
.tiles-group {

  .row {
    .col-12 {
      //padding: 10px !important;
    }
  }
  &__header {
    margin-bottom: 7px;
    border-bottom: 2px solid @color-primary;
    padding: 4px 0;
  }

  &__title {
    text-transform: uppercase;
    font-size: 16px;
    font-family: 'Roboto', Arial, sans-serif;
    font-weight: bold;
    line-height: 1;
  }

  &__btn {
    //min-height: 48px;
    //height: 100% !important;
    padding: 8px 15px !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    border-radius: 8px;

    ::v-deep {
      .v-btn:not(.v-btn--disabled) {
        background-color: #ced5de;
      }

      .v-btn__content {
        white-space: normal;
        flex-wrap: wrap;
        gap: 8px;
        width: 100%;
        text-align: left;
        justify-content: flex-start;
        position: static;
      }
    }
  }

  &__icon {
    font-size: 22px;
    width: 28px;
    display: inline-flex;
    justify-content: center;
    color: @color-primary;

    &_disabled {
      color: inherit  ;
    }
  }

  &__label {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    flex: 1 1 0;
    min-width: 0;
    word-break: break-word;
  }

  &__soon-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    font-size: 10px;
    line-height: 1;
    color: @color-soon-badge;
    text-transform: lowercase;
  }
}
</style>
